import { render, staticRenderFns } from "./ConsultaPublicaDocumentoAssinatura.vue?vue&type=template&id=096e0c7b&scoped=true"
import script from "./ConsultaPublicaDocumentoAssinatura.vue?vue&type=script&lang=js"
export * from "./ConsultaPublicaDocumentoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPublicaDocumentoAssinatura.vue?vue&type=style&index=0&id=096e0c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096e0c7b",
  null
  
)

export default component.exports